import { axios } from "@cores/axiosWrapper";

/**
 * 프로젝트에서 사용 중인 해시태그를 전방 일치로 조회한다 (태그 자동완성 추천용).
 * 추천은 부가 기능이라 실패해도 태그 입력을 막지 않는다 — customErrorMessage 로 공통 인터셉터의
 * 토스트·전역 errorStatus 처리를 건너뛰고 호출부가 조용히 무시한다.
 *
 * @param {string} apiEndpoint 스테이지 API 엔드포인트
 * @param {string} projectId 조회 대상 프로젝트 (헤더로 전달)
 * @param {{ value?: string, limit?: number, nextToken?: string }} params value 는 전방 일치 검색어, limit 기본 20
 * @returns {Promise<{ data: { results: string[], nextToken: string | null } }>}
 */
export const getHashtagsAPI = (apiEndpoint, projectId, params) =>
    axios.get(`${apiEndpoint}/hashtags`, { params, headers: { projectId }, customErrorMessage: true });
